import React from 'react';
import { TextField } from '@rmwc/textfield';
import { connect } from 'react-redux';
import { Select } from '@rmwc/select';
import * as actionCreator from "../../../../action/quote_order/leadcustomer.action.js";
import * as validate from '../../validations';
class AddEditAddressInfo extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         editAddress: false
      }
   }

   render() {
      let leadAddress = this.props.LeadCustomerData.address != undefined &&
         this.props.LeadCustomerData.address != '' &&
         this.props.LeadCustomerData.address.length > 0 &&
         this.props.LeadCustomerData.address.length > this.props.editAddressIndex ? this.props.LeadCustomerData.address[this.props.editAddressIndex] : ''
      let AddressData = (this.props.isAddress_Edit != '')
         ?
         leadAddress
         :
         (this.props.editId > 0 && this.state.editAddress == false)
            ?
            this.props.LeadCustomerData.address.filter((add) => {
               return add.id === this.props.editId
            })[0]
            :
            leadAddress
      if (AddressData == "") {
         AddressData = {}
         AddressData["address_line_1"] = this.props.LeadCustomerData.billing_address_line_1
         AddressData["address_line_2"] = this.props.LeadCustomerData.billing_address_line_2
         AddressData["city"] = this.props.LeadCustomerData.billing_city
         AddressData["county"] = this.props.LeadCustomerData.billing_county
         AddressData["state"] = this.props.LeadCustomerData.billing_state
         AddressData["zipcode"] = this.props.LeadCustomerData.billing_zipcode
      }

      let isValidate = ((this.props.displayerrorMessage?.address_line_1 == undefined || this.props.displayerrorMessage?.address_line_1 == '') && (this.props.displayerrorMessage?.address_line_2 == undefined || this.props.displayerrorMessage?.address_line_2 == '') && (this.props.displayerrorMessage?.zipcode == undefined || this.props.displayerrorMessage?.zipcode == '') && (this.props.displayerrorMessage?.county == undefined || this.props.displayerrorMessage?.county == '') && (this.props.displayerrorMessage?.city == undefined || this.props.displayerrorMessage?.city == '') && (this.props.displayerrorMessage?.state == undefined || this.props.displayerrorMessage?.state == '')) ? (((AddressData?.address_line_1 != undefined && AddressData?.address_line_1 != '') || (AddressData?.address_line_2 != undefined && AddressData?.address_line_2 != '') || (AddressData?.zipcode != undefined && AddressData?.zipcode != '') || (AddressData?.county != undefined && AddressData?.county != '') || (AddressData?.city != undefined && AddressData?.city != '') || (AddressData?.state != undefined && AddressData?.state != '')) ? true : false) : false
      let forEdit = this.props.editAddressShow ? "editable" : "new"
      return (
         <>
            <div className="form-group col-sm-6">
               <label class='control-label'>Address Line1</label>
               <div className={(this.props.displayerrorMessage.address_line_1 == '' || this.props.displayerrorMessage.address_line_1 == undefined) ? "floating-label-input" : "floating-label-input invalid-input"}>
                  <TextField
                     // fullwidth
                     rows={3}
                     name={this.props.from === "Installation" ? `shipping_address_line_1` : `billing_address_line_1`}
                     onChange={e => {
                        this.props.onAddressFiledChangeValue(e, 'address_line_1', 'address_line_1', 'LeadCustomer', 'NoValidate', "", this.props.from)
                        this.setState({ editAddress: true })
                     }
                     }
                     value={forEdit === "new"
                        ?
                        this.props.from === "Installation"
                           ?
                           this.props.LeadCustomerData.shipping_address_line_1
                           :
                           this.props.LeadCustomerData.billing_address_line_1
                        :
                        AddressData?.address_line_1}
                     maxLength={80}
                  />
                  <span className="error-icon icon-info-ico"></span>
                  <div className="errorMessage" id="fnameErrorMessage">{this.props.displayerrorMessage.address_line_1}</div>
               </div>
            </div>
            <div className="form-group col-sm-6">
               <label class='control-label'>Address Line2</label>
               <div className={(this.props.displayerrorMessage.address_line_2 == '' || this.props.displayerrorMessage.address_line_2 == undefined) ? "floating-label-input" : "floating-label-input invalid-input"}>
                  <TextField
                     // fullwidth
                     name={this.props.from === "Installation" ? `shipping_address_line_2` : `billing_address_line_2`}
                     onChange={e => {
                        this.props.onAddressFiledChangeValue(e, 'address_line_2', 'address_line_2', 'LeadCustomer', 'NoValidate', "", this.props.from)
                        this.setState({ editAddress: true })
                     }
                     }
                     value={forEdit === "new"
                        ?
                        this.props.from === "Installation"
                           ?
                           this.props.LeadCustomerData.shipping_address_line_2
                           :
                           this.props.LeadCustomerData.billing_address_line_2
                        :
                        AddressData?.address_line_2}
                     rows={3}
                     maxLength={80}
                  />
                  <span className="error-icon icon-info-ico"></span>
                  <div className="errorMessage" id="fnameErrorMessage">{this.props.displayerrorMessage.address_line_2}</div>
               </div>
            </div>
            <div className="form-group col-md-6">
               <label class='control-label'>Zip Code</label>
               <div className={(this.props.from === "Installation"
                  ?
                  (this.props.displayerrorMessage.shipping_zipcode == "" || this.props.displayerrorMessage.shipping_zipcode == undefined)
                  :
                  (this.props.displayerrorMessage.billing_zipcode == "" || this.props.displayerrorMessage.billing_zipcode == undefined)
               )
                  ? "floating-label-input" : "floating-label-input invalid-input"}>
                  <TextField
                     name={this.props.from === "Installation" ? `shipping_zipcode` : `billing_zipcode`}
                     maxLength="5"
                     onKeyUp={e => validate.onZipCodeValidate(e)}
                     // onKeyUp={e=> validate.numericCheckForZipCode(e)}
                     onChange={e => {
                        this.props.onAddressFiledChangeValue(e, 'zipcode', 'zipcode', 'LeadCustomer', 'NoValidate', "", this.props.from);
                        validate.onZipCodeValidate(e, this.props.from === "Installation" ? `shipping_zipcode` : `billing_zipcode`);
                        this.setState({ editAddress: true });
                     }
                     }
                     onBlur={e => validate.onZipCodeValidate(e, this.props.from === "Installation" ? `shipping_zipcode` : `billing_zipcode`)}
                     value={forEdit === "new"
                        ?
                        this.props.from === "Installation"
                           ?
                           this.props.LeadCustomerData.shipping_zipcode
                           :
                           this.props.LeadCustomerData.billing_zipcode
                        :
                        AddressData?.zipcode}
                     className="astrick"

                  />
                  <span className="error-icon icon-info-ico"></span>
                  <div className="errorMessage" id="zcodeErrorMessage">{this.props.from === "Installation" ? this.props.displayerrorMessage.shipping_zipcode : this.props.displayerrorMessage.billing_zipcode}</div>
               </div>
            </div>
            <div className="form-group col-md-6">
               <label class='control-label'>County</label>
               <div className={(this.props.from === "Installation"
                  ?
                  (this.props.displayerrorMessage.shipping_county == "" || this.props.displayerrorMessage.shipping_county == undefined)
                  :
                  (this.props.displayerrorMessage.billing_county == "" || this.props.displayerrorMessage.billing_county == undefined)
               )
                  ? "floating-label-input" : "floating-label-input invalid-input"}>
                  <TextField
                     name={this.props.from === "Installation" ? `shipping_county` : `billing_county`}
                     onChange={e => {
                        this.props.onAddressFiledChangeValue(e, 'county', 'County', 'LeadCustomer', 'NoValidate1', "", this.props.from);
                        validate.alphaSpaceValue(e, this.props.from === "Installation" ? `shipping_county` : `billing_county`);
                        this.setState({ editAddress: true });
                     }
                     }
                     onBlur={e => validate.alphaSpaceValue(e, this.props.from === "Installation" ? `shipping_county` : `billing_county`)}
                     value={forEdit === "new"
                        ?
                        this.props.from === "Installation"
                           ?
                           this.props.LeadCustomerData.shipping_county
                           :
                           this.props.LeadCustomerData.billing_county
                        :
                        AddressData?.county}
                     maxLength={30}
                  />
                  <span className="error-icon icon-info-ico"></span>
                  <div className="errorMessage" id="countryErrorMessage">{this.props.from === "Installation" ? this.props.displayerrorMessage.shipping_county : this.props.displayerrorMessage.billing_county}</div>
               </div>
            </div>
            <div className="form-group col-md-6">
               <label class='control-label'>City</label>
               <div className={(this.props.from === "Installation"
                  ?
                  (this.props.displayerrorMessage.shipping_city == "" || this.props.displayerrorMessage.shipping_city == undefined)
                  :
                  (this.props.displayerrorMessage.billing_city == "" || this.props.displayerrorMessage.billing_city == undefined)
               )
                  ? "floating-label-input" : "floating-label-input invalid-input"}>
                  <TextField
                     name={this.props.from === "Installation" ? `shipping_city` : `billing_city`}
                     onChange={e => {
                        this.props.onAddressFiledChangeValue(e, 'city', 'City', 'LeadCustomer', 'NoValidate1', "", this.props.from);
                        validate.alphaSpaceValue(e, this.props.from === "Installation" ? `shipping_city` : `billing_city`);
                        this.setState({ editAddress: true });
                     }
                     }
                     onBlur={e => validate.alphaSpaceValue(e, this.props.from === "Installation" ? `shipping_city` : `billing_city`)}
                     value={forEdit === "new"
                        ?
                        this.props.from === "Installation"
                           ?
                           this.props.LeadCustomerData.shipping_city
                           :
                           this.props.LeadCustomerData.billing_city
                        :
                        AddressData?.city}
                        maxLength={30}
                  />
                  <span className="error-icon icon-info-ico"></span>
                  <div className="errorMessage" id="cityErrorMessage">{this.props.from === "Installation" ? this.props.displayerrorMessage.shipping_city : this.props.displayerrorMessage.billing_city}</div>
               </div>
            </div>
            <div className="form-group col-md-6 d-none">
               <label class='control-label'>State</label>
               <div className={(this.props.displayerrorMessage.state == '' || this.props.displayerrorMessage.state == undefined) ? "floating-label-input" : "floating-label-input invalid-input"}>
                  <TextField
                     name={this.props.from === "Installation" ? `shipping_state` : `billing_state`}
                     onChange={e => {
                        this.props.onAddressFiledChangeValue(e, 'state', 'State', 'LeadCustomer', 'NoValidate1', "", this.props.from);
                        validate.alphaSpaceValue(e, 'state');
                        this.setState({ editAddress: true });
                     }
                     }
                     onBlur={e => validate.alphaSpaceValue(e, 'state')}
                     value={forEdit === "new"
                        ?
                        this.props.from === "Installation"
                           ?
                           this.props.LeadCustomerData.shipping_state
                           :
                           this.props.LeadCustomerData.billing_state
                        :
                        AddressData?.state}
                     maxLength={30}
                  />
                  <span className="error-icon icon-info-ico"></span>
                  <div className="errorMessage" id="stateErrorMessage">{this.props.displayerrorMessage.state}</div>
               </div>
            </div>
            <div className="form-group col-md-6 col-sm-12">
               <label class='control-label'>State</label>
               <div className={(this.props.displayerrorMessage.state == '' || this.props.displayerrorMessage.state == undefined) ? "floating-label-input floating-label-inside border-0" : "floating-label-input floating-label-inside border-0 invalid-input"}>
                  <Select
                     name={this.props.from === "Installation" ? `shipping_state` : `billing_state`}
                     value={forEdit === "new"
                        ?
                        this.props.from === "Installation"
                           ?
                           this.props.LeadCustomerData.shipping_state
                           :
                           this.props.LeadCustomerData.billing_state
                        :
                        AddressData?.state}
                     className='state-drop-down'
                     onChange={e => {
                        this.props.onAddressFiledChangeValue(e, 'state', 'State', 'LeadCustomer', 'NoValidate1', "", this.props.from);
                        validate.alphaSpaceValue(e, 'state');
                        this.setState({ editAddress: true });
                     }
                     }
                     onBlur={e => validate.alphaSpaceValue(e, 'state')}
                     defaultValue={{ label: "Select", value: "Select" }}
                     // options={this.props.const_var.stateManufacturerAcordingAPI[this.props.params.p_s_n].map((val, index) => { 
                     //          return (
                     //             {"value":val.id,
                     //             "label":val.name}
                     //          )                                   
                     //    })}
                     options={Object.entries(this.props.leadSourceStateData).map(([item, value]) => {
                        return { label: value, value: item }
                     })}
                  />
                  <span className="error-icon icon-info-ico"></span>
                  <div className="errorMessage" id="sourceErrorMessage">{this.props.displayerrorMessage.state}</div>
               </div>
            </div>
         </>
      )
   }
}
const mapStateToProps = (state) => {
   return state.leadcustomerReducer
}


export default connect(
   mapStateToProps,
   actionCreator
)(AddEditAddressInfo);